import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSectionNavigation } from "./contexts/SectionContext";
import logo from "../assets/images/logo_white.svg";

export default function Footer() {
  const { scrollToSection, activeSection } = useSectionNavigation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);

  const sections = [
    { id: "home", title: "Главная" },
    { id: "ecosystem", title: "Экосистема" },
    { id: "press", title: "Пресс-центр" },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 769);
      if (window.innerWidth >= 769) setIsMenuOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = (id, e) => {
    e.preventDefault();
    if (isMobile) setIsMenuOpen(false);

    if (location.pathname === "/") {
      scrollToSection(id);
    } else {
      navigate(`/#${id}`);
    }
  };
  return (
    <footer>
      <div className="container">
        <div className="footerContent">
          <img src={logo} alt="logo" />
          <div className="navContent">
            <div className="navBlock">
              <h4>Разделы</h4>
              <ul className="footerNav">
                {sections.map(({ id, title }) => (
                  <li key={id}>
                    <a
                      href={`#${id}`}
                      className={activeSection === id ? "active" : ""}
                      onClick={(e) => handleClick(id, e)}
                    >
                      {title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="navAddress">
              <h4>Контакты</h4>
              <a href="" className="btn btnAddress">
                Андропова пр-т, 8, Москва, Бизнес-центр “Мегаполис”
              </a>
              <a href="mailto:info@m-group.one" className="btn btnMail">
                info@m-group.one
              </a>
              <a href="tel:+74997008788" className="btn btnPhone">
                +7 (499) 700-87-88
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <p className="textBottom">©2025. М-ГРУПП</p>
      </div>
    </footer>
  );
}
